export const FIELD_MASK = {
  PHONE: "PHONE",
  HUF: "HUF",
};

export const STATEMENT_PROMPT_TYPE = {
  DOCUMENT: "DOCUMENT",
  LINK: "LINK",
};

export const LOGIN_STATUS = {
  LOGIN_OK: "LOGIN_OK",
  EMAIL_NOT_CONFIRMED: "EMAIL_NOT_CONFIRMED",
  PHONE_NOT_CONFIRMED: "PHONE_NOT_CONFIRMED",
  PASSWORD_CHANGE_REQUIRED: "PASSWORD_CHANGE_REQUIRED",
};

export const USER_STATUS = {
  REGISTERED: "REGISTERED",
  WAITING_FOR_FLOW: "WAITING_FOR_FLOW",
  IN_FLOW: "IN_FLOW",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
};

export const FLOW_POSITION = {
  INTRO: "INTRO",
  FLOW: "FLOW",
  OVERVIEW: "OVERVIEW",
  DATA_VALIDATION: "DATA_VALIDATION",
  KYC_PREPARATION: "KYC_PREPARATION",
  KYC_CHOOSE: "KYC_CHOOSE",
  KYC_WAITING: "KYC_WAITING",
  CONTRACT_CHECK: "CONTRACT_CHECK",
  SIGN_PREPARATION: "SIGN_PREPARATION",
  SIGN_CHOOSE: "SIGN_CHOOSE",
  SIGN_WAITING: "SIGN_WAITING",
  RESULT: "RESULT",
  CLOSED: "CLOSED",
  COMPLETED: "COMPLETED",
};

export const APPLICATION_STATUS = {
  RESULT: "RESULT",
  CLOSED: "CLOSED",
  COMPLETED: "COMPLETED",
};

export const FLOW_QUESTION_FIELD_TYPE = {
  SIMPLE_FIELD: "SIMPLE_FIELD",
  STATEMENT_PROMPT: "STATEMENT_PROMPT",
  DOCUMENT_PROMPT: "DOCUMENT_PROMPT",
  READONLY_FIELD: "READONLY_FIELD",
  SPECIAL_FIELD: "SPECIAL_FIELD",
};

export const SIMPLE_FIELD_TYPE = {
  INPUT: "INPUT",
  SELECT: "SELECT",
  CHECKBOX: "CHECKBOX",
  RADIO: "RADIO",
  DATE_PICKER: "DATE_PICKER",
};

export const SPECIAL_FIELD_TYPE = {
  SELF_ONBOARDING: "SELF_ONBOARDING",
  MERCHANT_BRANDING: "MERCHANT_BRANDING",
  DOC_GENERATE_AND_DOWNLOAD: "DOC_GENERATE_AND_DOWNLOAD",
};

export const SIGNATURE_PROCESS_STATUS = {
  NOT_READY: "NOT_READY",
  READY: "READY",
  WITHDRAWN: "WITHDRAWN",
  EXPIRED: "EXPIRED",
  ERROR_FOUND: "ERROR_FOUND",
};

export const CONDITIONAL_FIELD_OPERATOR = {
  ENUM: {
    AND: "AND",
    OR: "OR",
  },
};

export const SEARCH_FIELD_TYPES = {
  ENUM: "ENUM",
  DATE: "DATE",
  DATETIME: "DATETIME",
  TEXT: "TEXT",
  INTEGER: "INTEGER",
  LONG: "LONG",
  BOOLEAN: "BOOLEAN",
};

export const MERCHANT_APPLICATION_STATUS = {
  ENUM: {
    DATA_REGISTRY: "DATA_REGISTRY",
    DATA_VALIDATION: "DATA_VALIDATION",
    DOC_UPLOAD_STARTED: "DOC_UPLOAD_STARTED",
    DOC_UPLOADED: "DOC_UPLOADED",
    KYC_STARTED: "KYC_STARTED",
    KYC_PENDING: "KYC_PENDING",
    KYC_REVIEWING: "KYC_REVIEWING",
    KYC_COMPLETED: "KYC_COMPLETED",
    DOC_SIGN_STARTED: "DOC_SIGN_STARTED",
    DOC_SIGN_PENDING: "DOC_SIGN_PENDING",
    DOC_SIGN_REVIEWING: "DOC_SIGN_REVIEWING",
    DOC_SIGN_COMPLETED: "DOC_SIGN_COMPLETED",
    CONTRACT_CHECK: "CONTRACT_CHECK",
    CONTRACT_SIGN: "CONTRACT_SIGN",
    CONTRACT_SIGNED: "CONTRACT_SIGNED",
    RESULT: "RESULT",
    COMPLETED: "COMPLETED",
    CLOSED: "CLOSED",
  },
  TOKEN: {
    DATA_REGISTRY: "mp:merchant_application_status.enum.data_registry",
    DATA_VALIDATION: "mp:merchant_application_status.enum.data_validation",
    DOC_UPLOAD_STARTED:
      "mp:merchant_application_status.enum.doc_upload_started",
    DOC_UPLOADED: "mp:merchant_application_status.enum.doc_uploaded",
    KYC_STARTED: "mp:merchant_application_status.enum.kyc_started",
    KYC_PENDING: "mp:merchant_application_status.enum.kyc_pending",
    KYC_REVIEWING: "mp:merchant_application_status.enum.kyc_reviewing",
    KYC_COMPLETED: "mp:merchant_application_status.enum.kyc_completed",
    DOC_SIGN_STARTED: "mp:merchant_application_status.enum.doc_sign_started",
    DOC_SIGN_PENDING: "mp:merchant_application_status.enum.doc_sign_pending",
    DOC_SIGN_REVIEWING:
      "mp:merchant_application_status.enum.doc_sign_reviewing",
    DOC_SIGN_COMPLETED:
      "mp:merchant_application_status.enum.doc_sign_completed",
    CONTRACT_CHECK: "mp:merchant_application_status.enum.contract_check",
    CONTRACT_SIGN: "mp:merchant_application_status.enum.contract_sign",
    CONTRACT_SIGNED: "mp:merchant_application_status.enum.contract_signed",
    RESULT: "mp:merchant_application_status.enum.result",
    COMPLETED: "mp:merchant_application_status.enum.completed",
    CLOSED: "mp:merchant_application_status.enum.closed",
  },
};

export const PURCHASE_STATUS = {
  ENUM: {
    CREATED: "CREATED",
    LINKED: "LINKED",
    APPLICATION_STARTED: "APPLICATION_STARTED",
    APPLICATION_UNDER_REVIEW: "APPLICATION_UNDER_REVIEW",
    LOAN_APPROVED: "LOAN_APPROVED",
    MONEY_TRANSFERRED: "MONEY_TRANSFERRED",
    PAID: "PAID",
    REVOKED: "REVOKED",
    CANCELLED: "CANCELLED",
    DENIED: "DENIED",
  },
  TOKEN: {
    CREATED: "mp:purchase_status.enum.created",
    LINKED: "mp:purchase_status.enum.linked",
    APPLICATION_STARTED: "mp:purchase_status.enum.application_started",
    APPLICATION_UNDER_REVIEW:
      "mp:purchase_status.enum.application_under_review",
    LOAN_APPROVED: "mp:purchase_status.enum.loan_approved",
    MONEY_TRANSFERRED: "mp:purchase_status.enum.money_transferred",
    PAID: "mp:purchase_status.enum.paid",
    REVOKED: "mp:purchase_status.enum.revoked",
    CANCELLED: "mp:purchase_status.enum.cancelled",
    DENIED: "mp:purchase_status.enum.denied",
  },
};

export const LOAN_APPLICATION_STATUS_TOKENS = {
  DATA_REGISTRY: "mp:application.status.data_registry",
  DOC_UPLOAD_STARTED: "mp:application.status.doc_upload_started",
  DOC_UPLOADED: "mp:application.status.doc_uploaded",
  KYC_STARTED: "mp:application.status.kyc_started",
  KYC_PENDING: "mp:application.status.kyc_pending",
  KYC_REVIEWING: "mp:application.status.kyc_reviewing",
  KYC_COMPLETED: "mp:application.status.kyc_completed",
  DOC_SIGN_STARTED: "mp:application.status.doc_sign_started",
  DOC_SIGN_PENDING: "mp:application.status.doc_sign_pending",
  DOC_SIGN_REVIEWING: "mp:application.status.doc_sign_reviewing",
  DOC_SIGN_COMPLETED: "mp:application.status.doc_sign_completed",
  CONTRACT_CHECK: "mp:application.status.contract_check",
  CONTRACT_SIGN: "mp:application.status.contract_sign",
  CONTRACT_SIGNED: "mp:application.status.contract_signed",
  UNDER_REVIEW: "mp:application.status.under_review",
  BANK_RESULT: "mp:application.status.bank_result",
  PURCHASE_BANK_RESULT: "mp:application.status.purchase_bank_result",
  COMPLETED: "mp:application.status.completed",
  CLOSED: "mp:application.status.closed",
};

export const ROLES = {
  SUPER_ADMIN: "merchant_super_admin",
  ADMIN: "merchant_admin",
  DEVELOPER: "merchant_developer",
  USER: "merchant_user",
};

export const BNPL_DEAL_STATUS = {
  PREPARED: "PREPARED",
  CANCELLED: "CANCELLED",
  CANCELLED_FALLBACK: "CANCELLED_FALLBACK",
  INITIAL_PAYMENT_COMPLETED: "INITIAL_PAYMENT_COMPLETED",
  ONGOING: "ONGOING",
  ONGOING_DELAYED: "ONGOING_DELAYED",
  COMPLETED: "COMPLETED",
  INTERRUPTED: "INTERRUPTED",
};

export const BNPL_DEAL_STATUS_TOKENS = {
  PREPARED: "bnpl:deal.status.prepared",
  CANCELLED: "bnpl:deal.status.cancelled",
  CANCELLED_FALLBACK: "bnpl:deal.status.cancelled_fallback",
  INITIAL_PAYMENT_COMPLETED: "bnpl:deal.status.initial_payment_completed",
  ONGOING: "bnpl:deal.status.ongoing",
  ONGOING_DELAYED: "bnpl:deal.status.ongoing_delayed",
  COMPLETED: "bnpl:deal.status.completed",
  INTERRUPTED: "bnpl:deal.status.interrupted",
};

export const BNPL_DEAL_STATUS_RESULT_COLORS = {
  SUCCESS: "has-text-success",
  RETRY: "has-text-warning",
  FAILURE: "has-text-danger",
  CLOSED_APPROVED: "has-text-danger",
  CLOSED_REJECTED: "has-text-danger",
  CLOSED_TERMINATED: "has-text-danger",
  CLOSED_REQUIREMENTS_NOT_MET: "has-text-danger",
  CLOSED_UNAVAILABLE: "has-text-danger",
};

export const BNPL_DEAL_STATUS_RESULT_TOKENS = {
  SUCCESS: "bnpl:application.status_result.success",
  RETRY: "bnpl:application.status_result.retry",
  FAILURE: "bnpl:application.status_result.failure",
  CLOSED_APPROVED: "bnpl:application.status_result.approved",
  CLOSED_REJECTED: "bnpl:application.status_result.rejected",
  CLOSED_TERMINATED: "bnpl:application.status_result.terminated",
  CLOSED_REQUIREMENTS_NOT_MET: "bnpl:application.status_result.req_not_met",
  CLOSED_UNAVAILABLE: "bnpl:application.status_result.unavailable",
};

export const FLOW_POSITIONS = {
  INTRO: "INTRO",
  FLOW: "FLOW",
  OVERVIEW: "OVERVIEW",
  KYC_PREPARATION: "KYC_PREPARATION",
  KYC_CHOOSE: "KYC_CHOOSE",
  KYC_WAITING: "KYC_WAITING",
  CONTRACT_CHECK: "CONTRACT_CHECK",
  SIGN_PREPARATION: "SIGN_PREPARATION",
  SIGN_CHOOSE: "SIGN_CHOOSE",
  SIGN_WAITING: "SIGN_WAITING",
  UNDER_REVIEW: "UNDER_REVIEW",
  RESULT: "RESULT",
  CLOSED: "CLOSED",
};

export const BNPL_DEAL_STATUS_RESULT = {
  SUCCESS: "SUCCESS",
  RETRY: "RETRY",
  FAILURE: "FAILURE",
  SUPPLEMENT_REQUIRED: "SUPPLEMENT_REQUIRED",
  CLOSED_APPROVED: "CLOSED_APPROVED",
  CLOSED_REJECTED: "CLOSED_REJECTED",
  CLOSED_TERMINATED: "CLOSED_TERMINATED",
  CLOSED_REQUIREMENTS_NOT_MET: "CLOSED_REQUIREMENTS_NOT_MET",
  CLOSED_UNAVAILABLE: "CLOSED_UNAVAILABLE",
  CLOSED_TEST: "CLOSED_TEST",
};

export const BNPL_TRANSACTION_STATUS = {
  ENUM: {
    DUE: "DUE",
    PAID: "PAID",
    DELAYED: "DELAYED",
    CANCELLED: "CANCELLED",
    CANCELLED_SCORING: "CANCELLED_SCORING",
    CANCELLED_FALLBACK: "CANCELLED_FALLBACK",
    CANCELLED_PAY_IN_FULL: "CANCELLED_PAY_IN_FULL",
  },
  TOKEN: {
    DUE: "bnpl:application.transaction.status_result.due",
    STARTED: "bnpl:application.transaction.status_result.started",
    CANCELLED: "bnpl:application.transaction.status_result.cancelled",
    CANCELLED_SCORING:
      "bnpl:application.transaction.status_result.cancelled_scoring",
    CANCELLED_FALLBACK:
      "bnpl:application.transaction.status_result.cancelled_fallback",
    CANCELLED_PAY_IN_FULL:
      "bnpl:application.transaction.status_result.cancelled_pay_in_full",
    PAID: "bnpl:application.transaction.status_result.paid",
    DELAYED: "bnpl:application.transaction.status_result.delayed",
  },
  COLOR: {
    DUE: "",
    PAID: "has-text-success",
    DELAYED: "has-text-warning",
    STARTED: "",
    CANCELLED: "has-text-danger",
    CANCELLED_SCORING: "has-text-danger",
    CANCELLED_FALLBACK: "has-text-danger",
    CANCELLED_PAY_IN_FULL: "has-text-danger",
  },
};

export const LOAN_APPLICATION_DECISION_MODAL_TYPE = {
  REJECT: "REJECT",
  APPROVE: "APPROVE",
};

export const NOTE_ENTITY_NAME = {
  LOAN_APPLICATION: "LOAN_APPLICATION",
  BNPL_APPLICATION: "BNPL_APPLICATION",
};

export const BNPL_DEAL_TRANSACTION_ATTEMPT_STATUS = {
  ENUM: {
    SUCCESS: "SUCCESS",
    PENDING: "PENDING",
    FAILURE: "FAILURE",
    ERROR: "ERROR",
  },
  TOKEN: {
    SUCCESS: "bnpl:transaction_attempt.status_result.success",
    PENDING: "bnpl:transaction_attempt.status_result.pending",
    FAILURE: "bnpl:transaction_attempt.status_result.failure",
    ERROR: "bnpl:transaction_attempt.status_result.error",
  },
};

export const BNPL_DEAL_TRANSACTION_FLAG = {
  ENUM: {
    NONE: "NONE",
    DELAYED: "DELAYED",
    EXPIRED: "EXPIRED",
  },
  COLOR: {
    NONE: "",
    DELAYED: "has-text-danger",
    EXPIRED: "has-text-danger",
  },
  TOKEN: {
    NONE: "bnpl:transaction.label.flag.none",
    DELAYED: "bnpl:transaction.label.flag.delayed",
    EXPIRED: "bnpl:transaction.label.flag.expired",
  },
};

export const BNPL_APPLICATION_STATUS = {
  CREATED: "CREATED",
  INITIAL: "INITIAL",
  STARTED: "STARTED",
  CANCELLED: "CANCELLED",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  SIGNED: "SIGNED",
  COMPLETED: "COMPLETED",
  DENIED: "DENIED",
  INTERRUPTED: "INTERRUPTED",
  REJECT_FALLBACK: "REJECT_FALLBACK",
};

export const BNPL_SHOPPING_MODE_TOKENS = {
  IN_STORE: "bnpl:application.shopping_mode.in_store",
  WEB_SHOP: "bnpl:application.shopping_mode.web_shop",
  UNAS: "bnpl:application.shopping_mode.unas",
  SHOPIFY: "bnpl:application.shopping_mode.shopify",
  ONE_CLICK: "bnpl:application.shopping_mode.one_click",
};

export const BNPL_APPLICATION_STATUS_TOKENS = {
  CREATED: "bnpl:application.status.created",
  INITIAL: "bnpl:application.status.initial",
  STARTED: "bnpl:application.status.started",
  CANCELLED: "bnpl:application.status.cancelled",
  UNDER_REVIEW: "bnpl:application.under_review",
  APPROVED: "bnpl:application.status.approved",
  SIGNED: "bnpl:application.status.signed",
  COMPLETED: "bnpl:application.status.completed",
  DENIED: "bnpl:application.status.denied",
  INTERRUPTED: "bnpl:application.status.interrupted",
  DOC_SIGN_STARTED: "bnpl:application.status.doc_sign_started",
  CONTRACT_CHECK: "bnpl:application.status.contract_check",
  SCORING: "bnpl:application.status.scoring",
  REJECT_FALLBACK: "bnpl:application.status.reject_fallback",
};

export const BNPL_APPLICATION_STATUS_RESULT_COLORS = {
  SUCCESS: "has-text-success",
  RETRY: "has-text-warning",
  FAILURE: "has-text-danger",
  CLOSED_APPROVED: "has-text-danger",
  CLOSED_REJECTED: "has-text-danger",
  CLOSED_TERMINATED: "has-text-danger",
  CLOSED_REQUIREMENTS_NOT_MET: "has-text-danger",
  CLOSED_UNAVAILABLE: "has-text-danger",
  CLOSED_FALLBACK: "has-text-danger",
};

export const BNPL_APPLICATION_DECISION_MODAL_TYPE = {
  REJECT: "REJECT",
  APPROVE: "APPROVE",
};

export const BNPL_APPLICATION_STATUS_RESULT_TOKENS = {
  SUCCESS: "bnpl:application.status_result.success",
  RETRY: "bnpl:application.status_result.retry",
  FAILURE: "bnpl:application.status_result.failure",
  CLOSED_APPROVED: "bnpl:application.status_result.approved",
  CLOSED_REJECTED: "bnpl:application.status_result.rejected",
  CLOSED_TERMINATED: "bnpl:application.status_result.terminated",
  CLOSED_REQUIREMENTS_NOT_MET: "bnpl:application.status_result.req_not_met",
  CLOSED_UNAVAILABLE: "bnpl:application.status_result.unavailable",
  CLOSED_REFUNDED: "bnpl:application.status_result.refunded",
  CLOSED_FALLBACK: "bnpl:application.status_result.closed_fallback",
};

export const BNPL_APPLICATION_STATUS_RESULT = {
  SUCCESS: "SUCCESS",
  RETRY: "RETRY",
  FAILURE: "FAILURE",
  SUPPLEMENT_REQUIRED: "SUPPLEMENT_REQUIRED",
  CLOSED_APPROVED: "CLOSED_APPROVED",
  CLOSED_REJECTED: "CLOSED_REJECTED",
  CLOSED_TERMINATED: "CLOSED_TERMINATED",
  CLOSED_REQUIREMENTS_NOT_MET: "CLOSED_REQUIREMENTS_NOT_MET",
  CLOSED_UNAVAILABLE: "CLOSED_UNAVAILABLE",
  CLOSED_REFUNDED: "CLOSED_REFUNDED",
  CLOSED_FALLBACK: "CLOSED_FALLBACK",
};

export const FIELD_TYPE = {
  INPUT: "INPUT",
  SELECT: "SELECT",
  CHECKBOX: "CHECKBOX",
  RADIO: "RADIO",
  DATE_PICKER: "DATE_PICKER",
};

export const BNPL_FLOW_POSITIONS = {
  OVERVIEW: "OVERVIEW",
  INTRO: "INTRO",
  FLOW: "FLOW",
  SUMMARY: "SUMMARY",
  SCORING: "SCORING",
  CONTRACT_CHECK: "CONTRACT_CHECK",
  SIGNING_3RD: "SIGNING_3RD", // comnica
  SIGNING_SMS: "SIGNING_SMS", // sms
  FIRST_PAYMENT: "PAYMENT",
  PAYMENT_STARTED: "PAYMENT_STARTED",
  COMPLETED: "COMPLETED",
  CLOSED: "CLOSED",
};

export const SIGNATURE_CLOSE_REASON = {
  ENUM: {
    ERROR_FOUND: "ERROR_FOUND",
    CANCEL: "CANCEL",
    WITHDRAWN: "WITHDRAWN",
    EXPIRED: "EXPIRED",
  },
  LABEL: {
    ERROR_FOUND: "credit:loan_application.signature.close_reason.error_found",
    CANCEL: "credit:loan_application.signature.close_reason.cancel",
    WITHDRAWN: "credit:loan_application.signature.close_reason.withdrawn",
    EXPIRED: "credit:loan_application.signature.close_reason.expired",
  },
};
export const SIGNATURE_STATUS = {
  ENUM: {
    WAITING: "WAITING",
    ACCEPTED: "ACCEPTED",
    IN_PROGRESS: "IN_PROGRESS",
    SIGNED: "SIGNED",
    CLOSED: "CLOSED",
  },
  LABEL: {
    WAITING: "credit:loan_application.signature.status.waiting",
    ACCEPTED: "credit:loan_application.signature.status.accepted",
    IN_PROGRESS: "credit:loan_application.signature.status.in_progress",
    SIGNED: "credit:loan_application.signature.status.signed",
    CLOSED: "credit:loan_application.signature.status.closed",
  },
};

export const BNPL_LIMIT_STATUS = {
  STARTED: "STARTED",
  CANCELLED: "CANCELLED",
  ACTIVE: "ACTIVE",
  DENIED: "DENIED",
  INTERRUPTED: "INTERRUPTED",
  EXPIRED: "EXPIRED",
};

export const LIMIT_SOURCE = {
  APPLICATION: "APPLICATION",
  PROFILE: "PROFILE",
  EMAIL: "EMAIL",
  WEBSHOP: "WEBSHOP",
};

export const BNPL_LIMIT_STATUS_TOKENS = {
  STARTED: "bnpl:limit.tag.status.started",
  CANCELLED: "bnpl:limit.tag.status.cancelled",
  ACTIVE: "bnpl:limit.tag.status.active",
  DENIED: "bnpl:limit.tag.status.denied",
  INTERRUPTED: "bnpl:limit.tag.status.interrupted",
  EXPIRED: "bnpl:limit.tag.status.expired",
};

export const LIMIT_SOURCE_TOKENS = {
  APPLICATION: "bnpl:limit.tag.source.application",
  PROFILE: "bnpl:limit.tag.source.profile",
  EMAIL: "bnpl:limit.tag.source.email",
  WEBSHOP: "bnpl:limit.tag.source.webshop",
};

export const CUSTOMER_LIMIT_STATUS_TOKENS = {
  DRAFT: "mp:customer_limit.limit_status.draft",
  STARTED: "mp:customer_limit.limit_status.started",
  CANCELLED: "mp:customer_limit.limit_status.cancelled",
  ACTIVE: "mp:customer_limit.limit_status.active",
  DENIED: "mp:customer_limit.limit_status.denied",
  INTERRUPTED: "mp:customer_limit.limit_status.interrupted",
  EXPIRED: "mp:customer_limit.limit_status.expired",
};

export const DASHBOARD_GROUP_BY_PERIODS = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
};

export const DASHBOARD_VALUE_TYPE = {
  VALUE: "VALUE",
  VOLUME: "VOLUME",
};
export const BNPL_INSTANCE_TYPE = {
  MERCHANT_FINANCE: "MERCHANT_FINANCE",
  FACTORING: "FACTORING",
};
